<template>
  <div class="registration-page">
    <BigModal v-show="!isLoggedIn">
      <RegAuthForgot />
    </BigModal>

    <SeoTemplate
      :seo-title="get_seoPage.title"
      :seo-description="get_seoPage.description"
      twitter-img-url="/img/seo/registration/registration_1200_1200.jpg"
      og-img-url="/img/seo/registration/registration_1200_630.jpg"
    />
  </div>
</template>

<script>
import BigModal from '@/components/BigModal'
import RegAuthForgot from '@/components/BigModal/RegAuthForgot'
import SeoTemplate from '@/components/shared/SeoTemplate'
import { mapGetters, mapActions } from 'vuex'
import { storageService } from '~/services'

export default {
  name: 'RegistrationPage',
  components: {
    BigModal,
    RegAuthForgot,
    SeoTemplate,
  },
  beforeRouteLeave(_, __, next) {
    storageService.removeItem('regRoute')
    next()
  },
  layout: 'main-empty',
  async asyncData({ store, route }) {
    const isRefcode = route.query.hasOwnProperty('refcode')
    if (process.client || isRefcode) return

    await store.dispatch('promotions/fetch_partnerBanners', { query: '' })
  },
  data() {
    return {
      wasLoggedIn: false,
    }
  },
  async fetch() {
    return this.fetch_seoPage(this.$route.path)
  },

  head() {
    const baseUrl = (url) => this.$config.cloudUrl + url

    const mobBan = this.get_partnerBanners.banners?.banner_mobile
    const deskBan = this.get_partnerBanners.banners?.banner_desktop

    if (!this.get_partnerBanners.banners) return {}

    return {
      link: [
        {
          rel: 'preload', as: 'image',
          href: this.$device.isMobile ? baseUrl(mobBan) : baseUrl(deskBan),
        },
      ],
    }
  },
  computed: {
    ...mapGetters('user', { isLoggedIn: 'isLoggedIn' }),
    ...mapGetters('promotions', ['get_partnerBanners']),
    ...mapGetters('seo', ['get_seoPage']),
  },
  created() {
    if (!process.client) return
    this.wasLoggedIn = this.isLoggedIn
    if (this.isLoggedIn) {
      setTimeout(() => {
        this.$router.replace({ path: this.$paths.home })
      }, 1)
      return
    }
    if (!this.$route.query.bigModal) {
      setTimeout(() => {
        this.$newModal.openRegistration()
      })
    }
  },
  methods: {
    ...mapActions('promocode-new', ['send_promocode']),
    ...mapActions('promotions', ['fetch_partnerBanners']),
    ...mapActions('seo', ['fetch_seoPage']),
  },
}
</script>

<style>
.registration-page {
  min-height: 100vh;
}
</style>
